export enum DataLinkType {
  SHARE = 'share',
  COMPANY = 'company',
  ETF = 'etf',
  INVESTMENT_TRUST = 'investment_trust',
  FUND = 'fund',
  MANAGER = 'manager',
  RELATED_CONTENT = 'related_content',
  EXTERNAL_LINK = 'external_link',
  PRIVATE_MARKETS_FUND = 'private_markets_fund',
}
